// extracted by mini-css-extract-plugin
export default {"summary":"BasketCopySummary-summary-g8U","summaryTitle":"BasketCopySummary-summaryTitle-SVY","summaryActions":"BasketCopySummary-summaryActions-O48"};